/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TeamsInputs */

const cs_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Týmy`)
};

const en_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Nav_TeamsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_teams = /** @type {((inputs?: Nav_TeamsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TeamsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_teams(inputs)
	return cs_nav_teams(inputs)
});